import { RoleHost } from '../RoleHost';

export function WRWrapper() {
  return <RoleHost role="wr" />;
}
